import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const buildGASupportMessageColumns = ({ t, i18n }) => [
  {
    field: 'createdAt',
    headerName: t('ga.support.sentAt', { defaultValue: 'Sent' }),
    flex: 0.9,
    minWidth: 150,
    valueFormatter: (value) => (value ? new Date(value).toLocaleString(i18n.language) : ''),
  },
  {
    field: 'companyName',
    headerName: t('Company Name'),
    flex: 1,
    minWidth: 160,
  },
  {
    field: 'username',
    headerName: t('ga.company.username'),
    flex: 0.8,
    minWidth: 130,
  },
  {
    field: 'route',
    headerName: t('ga.support.page', { defaultValue: 'Page' }),
    flex: 0.8,
    minWidth: 130,
    valueGetter: (value, row) => row.context?.route || '',
  },
  {
    field: 'message',
    headerName: t('ga.support.message', { defaultValue: 'Message' }),
    flex: 2,
    minWidth: 260,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Typography variant="body2" noWrap>{params.value}</Typography>
        {params.row.hasScreenshot && <Chip icon={<ImageIcon fontSize="small" />} size="small" variant="outlined" label={t('ga.support.screenshot', { defaultValue: 'Screenshot' })} />}
      </Box>
    ),
  },
];

export default buildGASupportMessageColumns;
